export default __webpack_public_path__ + "static/6-7faaeac12fbfbbfafa1c852b77b16aac.jpg";